import { getImgSource } from '../../helpers/images.helpers';

import {
  type ConsolidatedSimplifiedActionDropdownItem,
  type SimplifiedActionDropdownItem,
} from './interfaces';

export function simplifiedActionDropdownItemToConsolidated(
  item: SimplifiedActionDropdownItem,
): ConsolidatedSimplifiedActionDropdownItem {
  return {
    id: item.id,
    label: item.label,
    imgSource: getImgSource(item.img),
    onClick: item.onClick,
    trailingIcon: item.trailingIcon,
  };
}
